import { createContext, useContext, useState } from "react";

interface SelectedTournamentContextValue {
    tournamentId: number | undefined;
    setTournamentId: (id: number | undefined) => void;
}

const SelectedTournamentContext = createContext<SelectedTournamentContextValue | undefined>(undefined);

export const SelectedTournamentProvider = ({ children }: { children: React.ReactNode }) => {
    const [tournamentId, setTournamentId] = useState<number | undefined>(undefined);

    return (
        <SelectedTournamentContext.Provider
            value={{
                tournamentId,
                setTournamentId,
            }}
        >
            {children}
        </SelectedTournamentContext.Provider>
    );
};

export const useSelectedTournament = (): SelectedTournamentContextValue => {
    const context = useContext(SelectedTournamentContext);
    if (!context) {
        throw new Error("useSelectedTournament must be used within a SelectedTournamentProvider");
    }
    return context;
};
